import { cn } from '@latitude/token-utils';
import * as LabelPrimitive from '@radix-ui/react-label';
import type { ComponentPropsWithoutRef, ComponentRef, Ref } from 'react';
import { checkboxLabelClasses } from 'variants/checkbox-variants';

export const CheckboxLabel = ({
  className,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & {
  ref?: Ref<ComponentRef<typeof LabelPrimitive.Root>>;
}) => {
  return (
    <LabelPrimitive.Root
      {...props}
      ref={ref}
      className={cn(checkboxLabelClasses, className)}
    />
  );
};

CheckboxLabel.displayName = 'CheckboxLabel';
